import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MiscellaneousComponent } from './error-page.component';
import { PageNotFoundComponent } from './404/page-not-found.component';

const routes: Routes = [
    {
        path: '',
        component: MiscellaneousComponent,
        children: [
            {
                path: '/pages/404-not-found',
                component: PageNotFoundComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MiscellaneousRoutingModule {
}